import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U2104OrganizationPersonalizationHandler } from "./U2104OrganizationPersonalizationHandlers";
import { ORGANIZATION_PERSONALIZATION_NAME_TYPES } from "../../../common/organizationPersonalizationTypes";
import { useTranslation } from "react-i18next";

// Typage des props du composant
interface U2104OrganizationPersonalizationDeleteDlgProps {
  u2104OrganizationPersonalizationHandler: U2104OrganizationPersonalizationHandler;
  t: TFunction;
  NS: string;
}

function U2104OrganizationPersonalizationDeleteDlg({ u2104OrganizationPersonalizationHandler, t, NS }: U2104OrganizationPersonalizationDeleteDlgProps) {
  const { i18n } = useTranslation();

  if (!u2104OrganizationPersonalizationHandler.isDeleteDialogOpen) return null;

  // Fonction helper pour obtenir le label traduit
  const getTranslatedLabel = (personalizationName: string): string => {
    const personalizationType = ORGANIZATION_PERSONALIZATION_NAME_TYPES.find((type) => type.value === personalizationName);
    if (personalizationType) {
      const label = typeof personalizationType.label === "object" ? (i18n.language === "fr" ? personalizationType.label.fr : personalizationType.label.en) : String(personalizationType.label);
      return label;
    }
    // Fallback sur la valeur de l'enum si le type n'est pas trouvé
    return personalizationName;
  };

  return (
    <U2000DeleteRecordDialog
      isOpen={u2104OrganizationPersonalizationHandler.isDeleteDialogOpen}
      onClose={u2104OrganizationPersonalizationHandler.onDlgDeleteClose}
      title={t("tabPersonalization", { ns: NS })}
    >
      <p className="mb-4">
        {t("msgDeleteOrganizationPersonalization", {
          count: u2104OrganizationPersonalizationHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u2104OrganizationPersonalizationHandler.gridStateHandlers.getSelectedRows().map((row, index, array) => (
          <span key={row.id} className="inline-block text-gray-800">
            {getTranslatedLabel(row.personalizationName)}
            {index < array.length - 1 && ", "}
          </span>
        ))}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U2104OrganizationPersonalizationDeleteDlg;
